<sh-form-group
    [invalid]="isControlInvalid$ | async"
    [required]="isControlRequired$ | async"
    [label]="label"
    [labelIcons]="labelIcons"
    [helpText]="helpText"
    [currentActionItems]="currentActionItems"
    [describeLabelId]="describeLabelId"
    [errorMsg]="errorMsg"
    [id]="controlId"
    [formGroupStyling]="formGroupStyling"
>
    <div slot="inputPrefix">
        <ng-content></ng-content>
    </div>

    <sh-form-dual-list-base
        [id]="controlId"
        [formControl]="control"
        [allOptions]="allOptions"
        [initialSelectedOptions]="initialSelectedOptions"
        [i18n]="i18n"
        [leftHeaderText]="leftHeaderText"
        [rightHeaderText]="rightHeaderText"
        [leftHasError]="leftHasError"
        [rightHasError]="rightHasError"
        [invalid]="isControlInvalid$ | async"
        [isDisabled]="isControlDisabled$ | async"
        [disabledMsg]="disabledInfoMsg"
    ></sh-form-dual-list-base>
</sh-form-group>
